import { Modal } from '@components/Customized';
import PurchaseOrderViewPresenter from './PurchaseOrderViewPresenter';
import { PurchaseOrderViewPresenterProps } from './types';

interface PurchaseOrderHistoryModalProps
  extends PurchaseOrderViewPresenterProps {
  open: boolean;
  onClose: () => void;
}

const PurchaseOrderHistoryModal = ({
  open,
  onClose,
  ...restProps
}: PurchaseOrderHistoryModalProps) => {
  return (
    <Modal open={open} onClose={onClose} maxWidth={648}>
      <Modal.ContentSection>
        <PurchaseOrderViewPresenter {...restProps} isHistory />
      </Modal.ContentSection>
    </Modal>
  );
};

export default PurchaseOrderHistoryModal;
